import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ?bots=1 on any page shows the hidden "Play a bot" card on this device, even
// if a sign-in or redirect drops the query before the lobby sees it.
try {
  const bots = new URLSearchParams(window.location.search).get("bots");
  if (bots === "1") localStorage.setItem("jangle_bots", "1");
  if (bots === "0") localStorage.removeItem("jangle_bots");
} catch {}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
